import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { AppBreadcrumbComponent } from 'src/app/layouts/full/shared/breadcrumb/breadcrumb.component';
import { MaterialModule } from 'src/app/material.module';
import { DrugListComponent } from './drug-list/drug-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { GenericContentListComponent } from './generic-content-list/generic-content-list.component';
import { DrugCompanyListComponent } from './drug-company/drug-company-list.component';
import { DrugTypeListComponent } from './drug-type/drug-type-list.component';

@Component({
  selector: 'app-drug-tab',
  imports: [
    AppBreadcrumbComponent,
    CommonModule,
    MaterialModule, 
    TablerIconsModule,
    DrugListComponent,
    TranslateModule,
    GenericContentListComponent,
    DrugCompanyListComponent,
    // DrugTypeListComponent
  ],
  templateUrl: './drug-tab.component.html',
  styleUrl: './drug-tab.component.scss'
})
export class DrugTabComponent {

}
